import wretch from 'wretch';

import { type LoadServerCxModuleOptions } from '@cx-modules/client';
import { configureErrorCatchers } from '@cx-modules/errors';
import { getEnvContextualizedCxEndpoint } from '@cx-modules/utils';

import { type LoadTextBlockArgs } from '../types';

export type TextBlockRequestParams = Omit<LoadTextBlockArgs, 'dataApiEndpoint'>;

export type TextBlockResponseData = {
  body: string;
  id: number;
  title: string;
};

export const fetchTextBlockData = async (
  dataApiEndpoint = getEnvContextualizedCxEndpoint(),
  params: TextBlockRequestParams,
  options?: LoadServerCxModuleOptions,
): Promise<TextBlockResponseData | null> => {
  const { id, level, repub } = params;
  const url = new URL(`${dataApiEndpoint}/v1/evergreen/${level}`);

  const client = configureErrorCatchers(
    wretch(`${url.toString()}?id=${id}`, {
      headers: {
        accept: 'application/json',
        'content-type': 'application/json',
        repub,
        ...(options?.nocache && { 'Cache-Control': 'no-cache' }),
      },
    }),
    options,
  );

  return client.get().json<TextBlockResponseData>();
};

export const getTextBlockCacheKey = ({ id, repub }: TextBlockRequestParams) => [`text-block-${id}`, repub];
